
import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  expandForm: {
    paddingBottom: theme.spacing.unit,
    width: '100%'
  },
  expandColumn: {
    flexBasis: '50%',
    margin: 'auto'
  }
});

const MobileSessionListHeader = ({ t, classes }) => (
  <ExpansionPanel expanded={false}>
    <ExpansionPanelSummary>
      <div className={classes.expandColumn}>
        <Typography variant="title">{t('Case ID')}</Typography>
      </div>
      <div className={classes.expandColumn} style={{ paddingRight: '0px' }}>
        <Typography variant="caption" align="right">{t('Click to View Details')}</Typography>
      </div>
    </ExpansionPanelSummary>
  </ExpansionPanel>
)

MobileSessionListHeader.propTypes = {
  t: PropTypes.func,
  classes: PropTypes.object
}

export default compose(
  translate(),
  withStyles(styles)
)(MobileSessionListHeader)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Mobile/SessionListHeader.js